import * as fetch from 'portable-fetch';
import * as $ from "jquery";
import globalState from "../global-state";
import {LS_DRC_IDENTITY_ANONYMOUS} from "../constants";
import _get from 'lodash-es/get';
import {DestinationDto} from "../api/generated";

/**
 * Includes an external resource (markup) into the DOM.
 * @param element an DOM element where the loaded resource should be included
 * @param resourceUrl the url of the external resource
 * @param replace if true, replaces the element, appends it otherwise
 * @returns a promise that succeeds when the resource has been added to the DOM
 */
export const include = function (element: String | Element, resourceUrl: string, replace: boolean = false): Promise<void> {
    return loadMarkup(resourceUrl)
        .then(markup => {
            if (replace) {
                $(element).replaceWith(markup);

            } else {
                $(element).append(markup);
            }
        });
};

export const loadMarkup = function (resourceUrl: string): Promise<string> {
    return fetch(resourceUrl, {redirect: 'follow'})
        .then(response => {
            if (response.status === 200) {
                return response.text();

            } else {
                return Promise.reject(response.status);
            }
        })
        .catch(err => {
            console.error('failed to load', resourceUrl, err);
            return Promise.reject(err);
        });
};

/**
 * Gets the identity from global state user or cookie in request.
 * @param options the request options
 */
export const identity = function (options?: any) {
    return globalState.user() ? globalState.user().sessionId :
        (_get(options, 'headers.Cookie') && _get(options, 'headers.Cookie').split('=')[1]) ||
        LS_DRC_IDENTITY_ANONYMOUS;
};

// noinspection JSUnusedGlobalSymbols
/**
 * Use scrollToError binding is preferred.
 * @param complete a callback that gets executed, when the scrolling completes
 */
export const scrollToError = function (complete: () => void) {
    const $failedElement = $('.validationMessage').first();
    if ($failedElement.length > 0) {
        $failedElement.each(function () {
            $('html').animate({
                scrollTop: $failedElement.offset().top - 200
            }, 'fast', 'swing', function () {
                complete();
            });
        });

    } else {
        complete();
    }
};

/**
 * Check if a destination is selectable for a trip.
 * @param destination
 */
export const isAllowedDestination = function (destination: DestinationDto): boolean {
    return destination.type == DestinationDto.TypeEnum.Country
        || destination.type == DestinationDto.TypeEnum.Region
        || destination.type == DestinationDto.TypeEnum.City
};
